import { footerColumns } from '@/mocks/indexNav';

const hrefMap: Record<string, string> = {
  黑料索引总览: '#index',
  分类索引导航: '#index',
  地区动态目录: '#guide',
  时间归档列表: '#guide',
  热度榜单: '#ranking',
  专题合辑: '#topics',
  短讯速览: '#feed',
  编辑精选: '#topics',
  收录标准: '#overview',
  更新频率: '#overview',
  内容声明: '#overview',
  联系与反馈: '#guide',
};

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="h-1 w-full bg-primary-500" />
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 font-heading text-xl font-bold text-background-50">
                料
              </span>
              <div>
                <span className="font-heading text-xl font-bold text-background-50">黑料一区</span>
                <span className="mt-0.5 block font-label text-[10px] tracking-[0.3em] text-accent-300">INDEX PORTAL</span>
              </div>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/70">
              黑料索引导航与目录总览平台，把条目按题材、热度、地区与时间归档，按图索骥不迷路。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="#index"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-100/20 text-background-100/80 cursor-pointer transition-colors hover:border-accent-300 hover:text-accent-300"
                aria-label="索引目录"
              >
                <i className="ri-links-line" />
              </a>
              <a
                href="#ranking"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-100/20 text-background-100/80 cursor-pointer transition-colors hover:border-accent-300 hover:text-accent-300"
                aria-label="热度榜单"
              >
                <i className="ri-fire-line" />
              </a>
              <a
                href="#topics"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-100/20 text-background-100/80 cursor-pointer transition-colors hover:border-accent-300 hover:text-accent-300"
                aria-label="专题合辑"
              >
                <i className="ri-bookmark-3-line" />
              </a>
              <a
                href="#guide"
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-100/20 text-background-100/80 cursor-pointer transition-colors hover:border-accent-300 hover:text-accent-300"
                aria-label="指引目录"
              >
                <i className="ri-route-line" />
              </a>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title}>
              <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">{column.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href={hrefMap[link] ?? '#index'}
                      className="text-sm text-background-100/70 cursor-pointer transition-colors hover:text-accent-300"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-100/15 pt-6 text-xs text-background-100/55 sm:flex-row sm:items-center sm:justify-between">
          <span>© 2026 黑料一区 · 内容索引聚合门户</span>
          <span className="leading-relaxed">
            本页面为静态结构演示，全部条目均为示例数据，不指向任何真实个人或事件。
          </span>
        </div>
      </div>
    </footer>
  );
}